<template>
  <div class="mt-2" v-if="storageInfo">
    <div @click="setDirectoryType()" class="card  shadow-none mb-2" :class="[!selected ? 'active' : 'border']">
      <a href="javascript: void(0);" class="text-body">
        <div class="p-2">
          <div class="d-flex">
            <div class="avatar-xs align-self-center me-2">
              <div class="avatar-title rounded bg-transparent text-success font-size-20">
                <i class="mdi mdi-folder"></i>
              </div>
            </div>

            <div class="overflow-hidden me-auto">
              <h5 class="font-size-13 text-truncate mb-1">{{ $t("common.all") }}</h5>
              <p class="text-muted text-truncate mb-0">{{ storageInfo.totalCount }} {{ $t("file-manager.file") }}</p>
            </div>

            <div class="ms-2 ml-3">
              <p class="text-muted">{{ getUsage | formatByte }}</p>
            </div>
          </div>
        </div>
      </a>
    </div>

    <div
      v-for="item in storageInfo.directories"
      :key="item.name"
      @click="setDirectoryType(item.name)"
      class="card shadow-none mb-2"
      :class="[selected == item.name ? 'active' : 'border']"
    >
      <a href="javascript: void(0);">
        <div class="p-2">
          <div class="d-flex">
            <div class="avatar-xs align-self-center me-2">
              <div class="avatar-title rounded bg-transparent text-danger ">
                <i :class="icon(item.name)"></i>
              </div>
            </div>

            <div class="overflow-hidden me-auto">
              <h5 class="font-size-13 text-truncate mb-1">{{ directoryName(item.name) }}</h5>
              <p class="text-muted text-truncate mb-0">{{ item.count }} {{ $t("file-manager.file") }}</p>
            </div>

            <div class="ms-2 ml-3">
              <p class="text-muted">{{ item.size | formatByte }}</p>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: { storageInfo: { required: true }, selected: { required: false }, scope: { required: false } },
  computed: {
    getUsage() {
      if (this.scope) {
        return this.storageInfo?.[this.scope]?.usage;
      }
      return this.storageInfo.used;
    },
  },
  methods: {
    icon(directory) {
      if (directory == "TASK") {
        return "iconoir-archery font-size-20 ";
      } else if (directory == "APPLICATION") {
        return "iconoir-bookmark-book font-size-20 ";
      } else if (directory == "LEGAL_DOCUMENT") {
        return "iconoir-book font-size-20 ";
      } else if (directory == "INVENTORY") {
        return "iconoir-network-right font-size-20 ";
      } else if (directory == "TEMP") {
        return "iconoir-eye-closed font-size-20 ";
      } else if (directory == "REPORT") {
        return "bx bx-file font-size-20 ";
      }
    },
    directoryName(directory) {
      if (directory == "TASK") {
        return this.$t("task.plural");
      } else if (directory == "APPLICATION") {
        return this.$t("application.text");
      } else if (directory == "LEGAL_DOCUMENT") {
        return this.$t("legal-document.text");
      } else if (directory == "INVENTORY") {
        return this.$t("inventory.text");
      } else if (directory == "TEMP") {
        return this.$t("file-manager.temp");
      } else if (directory == "REPORT") {
        return this.$t("report.plural");
      }
    },
    setDirectoryType(value) {
      this.$emit("directoryTypeSelected", value);
    },
  },
};
</script>
<style scoped>
.active {
  border: 1px solid rgba(85, 110, 230, 0.85);
}
</style>
